import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import './clients_expo.css'
import { FaUndo } from "react-icons/fa";
  
function DeletedClientsExpo({ setUpdateTrigger, updateTrigger }){

    const [deletedEntries, setDeletedEntries] = useState([]);

    const getDeletedEntries = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_URL_BACKEND}/api/v1/exp_clients/deleted`, {
                headers: {
                    Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                },
            });
            if (res.status === 200) {
                setDeletedEntries(res.data.data);
            } else {
                Swal.fire("Error", "Hubo un error al obtener los datos eliminados", "error");
            }
        } catch (error) {
            Swal.fire("Error", "Hubo un error al obtener los datos eliminados", "error");
        }
    };

    const restorePaymentCondition = async (id) => {
        try {
            const result = await Swal.fire({
                title: "¿Estás seguro?",
                text: "¿Quieres restaurar este elemento?",
                icon: "warning",
                showDenyButton: true,
                confirmButtonText: "Sí, restaurar",
                denyButtonText: "No, cancelar",
                reverseButtons: true,
                buttonsStyling: true,
            });

            if (result.isConfirmed) {
                const response = await axios.put(`${process.env.REACT_APP_URL_BACKEND}/api/v1/exp_clients/restore/${id}`, {
                    headers: {
                        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                    },
                });

                Swal.fire("¡Restaurado!", "El elemento ha sido restaurado.", "success");
                setUpdateTrigger(!updateTrigger);
                getDeletedEntries();
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.fire("Cancelado");
            }
        } catch (error) {
            Swal.fire("Error", "Hubo un error", "error");
        }
    };

    useEffect(() => {
        getDeletedEntries();
    }, [updateTrigger]);

    return (
        <div className='table-responsive'>
            <h3 className="mb-4">Elementos eliminados</h3>
            <table className="table table-inverse table-hover table-striped table-bordered dataTable no-footer" role="grid">
                <thead>
                    <tr>
                        <th style={{ width: "343.25px" }}>Nombre</th>
                        <th style={{ width: "343.25px" }}>RFC</th>
                        <th style={{ width: "343.25px" }}>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {deletedEntries.map((paycond) => (
                        <tr key={paycond.id} data-master-id={paycond.id}>
                            <td>{paycond.name}</td>
                            <td>{paycond.rfc}</td>
                            <td>
                                <FaUndo className='restoreButton' onClick={() => { restorePaymentCondition(paycond.id) }} />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );

}

export default DeletedClientsExpo;